/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespIconBubbles_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
